const select_date = {
    namespaced: true,
    state: {
        visible: false,

        resolve: null,
        reject: null,

        title: "Выберите_дату",
        text: "Дата",
        date: null,

        minDate: null,
        maxDate: null,
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_TITLE(state, payload){
            state.title = payload ?? "Выберите_дату";
        },
        SET_TEXT(state, payload){
            state.text = payload ?? "Дата";
        },
        SET_DATE(state, payload) {
            state.date = payload ? this._vm.$moment(payload) : null;
        },
        SET_MIN_DATE(state, payload) {
            state.minDate = payload ? this._vm.$moment(payload).add(1, 'days') : null;
        },
        SET_MAX_DATE(state, payload) {
                state.maxDate = payload ? this._vm.$moment(payload) : null;
        },
    },
    actions: {
        async open({ state, commit }, { title, text, date = null, min = null, max = null }) {
            commit('SET_TITLE', title);
            commit('SET_TEXT', text);
            commit('SET_MIN_DATE', min);
            commit('SET_MAX_DATE', max);
            const _date = this._vm.$moment(date);
            if (state.min && state.min.isAfter(_date))
                commit('SET_DATE', min);
            else if (state.max && state.max.isBefor(_date))
                commit('SET_DATE', max);
            else 
                commit('SET_DATE', date);

            commit('SET_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve(state.date.format('YYYY-MM-DD'));
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        getTitle: (s) => s.title,
        getText: (s) => s.text,
        getDate: (s) => s.date ? s.date.format('YYYY-MM-DD') : null,
        getMinDate: (s) => s.minDate ? s.minDate.format('YYYY-MM-DD') : null,
        getMaxDate: (s) => s.maxDate ? s.maxDate.format('YYYY-MM-DD') : null
    }
}

export default select_date;